var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_-_Expand_use_this_one","data-name":"Icon - Expand use this one","transform":"translate(1 1)"},[React.createElement("line",{"id":"Line_152","data-name":"Line 152","x2":"10","transform":"translate(0 5)","fill":"none","stroke":"#3d5265","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_153","data-name":"Line 153","y1":"10","transform":"translate(5)","fill":"none","stroke":"#3d5265","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Expand.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Expand;

Expand.default = Expand;
